<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="收货质检" @click-left="onClickLeft" @click-right="goIndex()"/>
    <div>
      <van-cell-group>
        <van-field ref="_ansNo" v-model="order.no" autofocus clearable label="订单编号" left-icon="photograph" placeholder="请扫描订单编号" @keyup="onAsnNoEntered"/>
      </van-cell-group>
    </div>
    <div>
      <van-cell-group>
        <van-field ref="_itemNo" v-model="detail.item.no" autofocus clearable label="商品编号" left-icon="photograph" placeholder="请扫描商品条码" @keyup="onItemNoEntered"/>
      </van-cell-group>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item name="1" title="单据信息">
        <van-field v-model="order.no" label="订单编号" name="订单编号" readonly/>
        <van-field v-model="order.orderType.name" label="订单类型" name="订单类型" readonly/>
        <van-field :value="order.asnOrder.orderStatus" label="订单状态" name="订单状态" readonly>
          <span slot="input">{{orderStatus.find(item => item.ordinal === order.asnOrder.orderStatus)?.name}}</span>
        </van-field>
        <van-field v-model="order.owner.name" label="货主名称" name="货主名称" readonly/>
        <van-field v-model="order.asnOrder.customer.name" label="供应商" name="供应商" readonly/>
        <van-field v-model="order.operator" label="收货员" name="收货员" readonly/>
      </van-collapse-item>
      <van-collapse-item name="2" title="商品信息">
        <van-field v-model="detail.item.no" label="商品编号" name="商品编号" readonly/>
        <van-field v-model="detail.item.name" label="商品名称" name="商品名称" readonly/>
        <van-field v-model="detail.item.barcodes" label="商品条码" name="商品条码" readonly/>
        <van-field v-model="detail.item.legalAttribute.name" label="法定属性" name="法定属性" readonly/>
        <van-field v-model="detail.item.dosageForm.name" label="商品剂型" name="商品剂型" readonly/>
        <van-field v-model="detail.item.permitHolder" label="许可持有人" name="许可持有人" readonly/>
        <van-cell center title="贵重">
          <van-switch v-model="detail.item.valuable" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
        <van-cell center title="特管">
          <van-switch v-model="detail.item.special" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
        <van-cell center title="易碎">
          <van-switch v-model="detail.item.fragile" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
        <van-cell center title="视觉复核">
          <van-switch v-model="detail.item.visualized" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
        <van-cell center title="监管">
          <van-switch v-model="detail.item.supervised" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
      </van-collapse-item>
      <van-collapse-item name="3" title="包装信息">
        <van-field v-model="detail.pack.specification" label="包装规格" name="包装规格" readonly/>
        <van-field v-model="detail.pack.uom" label="包装单位" name="包装单位" readonly/>
        <van-field v-model="detail.pack.factor" label="件装量" name="件装量" readonly/>
        <van-field v-model="detail.pack.innerFactor" label="内包量" name="内包量" readonly/>
      </van-collapse-item>
      <van-collapse-item name="4" title="批号信息">
        <van-field v-model="detail.lot.no" label="批号" name="批号" readonly/>
        <van-field v-model="detail.lot.productionDate" class="normalFont" label="生产日期" name="生产日期" readonly/>
        <van-field v-model="detail.lot.validUntil" label="有效期至" name="有效期至" readonly/>
        <van-field v-model="detail.lot.manufacturer" label="生产厂家" name="生产厂家" readonly/>
        <van-field v-model="detail.lot.producingArea" label="商品产地" name="商品产地" readonly/>
        <van-field v-model="detail.lot.approvalNo" label="批准文号" name="批准文号" readonly/>
        <van-collapse-item name="4" title="执照">
          <van-field v-model="detail.lot.license.licenseNo" label="执照号" name="执照号" readonly/>
          <van-field v-model="detail.lot.license.licenseExpirationDate" label="有效期" name="有效期" readonly/>
        </van-collapse-item>
        <van-collapse-item name="4" title="许可证">
          <van-field v-model="detail.lot.permission.permissionNo" label="许可证号" name="许可证号" readonly/>
          <van-field v-model="detail.lot.permission.permissionEffectiveDate" label="生效期" name="生效期" readonly/>
          <van-field v-model="detail.lot.permission.permissionExpirationDate" label="有效期" name="有效期" readonly/>
        </van-collapse-item>
        <van-collapse-item name="4" title="规范">
          <van-field v-model="detail.lot.practice.practiceNo" label="规范证号" name="规范证号" readonly/>
          <van-field v-model="detail.lot.practice.practiceExpirationDate" label="有效期" name="有效期" readonly/>
        </van-collapse-item>
        <van-collapse-item name="4" title="质量标准">
          <van-field v-model="detail.lot.quality.qualityStandard" label="标准" name="标准" readonly/>
          <van-field v-model="detail.lot.quality.qualityExpirationDate" label="有效期" name="有效期" readonly/>
        </van-collapse-item>
      </van-collapse-item>
      <van-collapse-item name="5" title="收货信息">
        <van-field v-model="summary.totalQuantity" label="收货总数" name="收货总数" readonly/>
        <van-field v-model="summary.unreceivedQuantity" label="未收货数" name="未收货数" readonly/>
        <van-field v-model="summary.receivedQuantity" label="收货数量" name="收货数量" readonly/>
        <van-field v-model="summary.rejectedQuantity" label="拒收数量" name="拒收数量" readonly/>
        <van-field v-model="summary.unacceptedQuantity" label="未验收数" name="未验收数" readonly/>
        <van-field v-model="summary.acceptedQuantity" label="验收数量" name="验收数量" readonly/>
        <van-field v-model="summary.rejectedQuantityOfAcceptance" label="拒验数量" name="拒验数量" readonly/>
      </van-collapse-item>
      <van-collapse-item name="6" title="录入信息">
        <van-field v-model="detail.acceptedQuantity" clearable label="数量" name="数量" type="number" @change="changeQuantity"/>
        <van-field v-model="summary.receivedCase" clearable label="箱数" name="箱数" type="number" @change="changeCase"/>
        <van-field v-model="detail.rejectedQuantityOfAcceptance" clearable label="拒验数量" name="拒验数量" type="number"/>
        <van-field :value="detail.storageRoom.name" label="库房" name="storageRoomPicker" readonly right-icon="clear" @focus="showStorageRooms=true" @click-right-icon="clearStorageRoom"/>
        <van-popup v-model="showStorageRooms" position="bottom">
          <van-picker :columns="storageRooms" show-toolbar value-key="name" @cancel="showStorageRooms=false" @confirm="changeStorageRoom"/>
        </van-popup>
        <van-field v-model="detail.container.no" clearable label="容器编号" name="容器编号" @keyup="onContainerNo"/>
        <van-field :value="detail.receiptConclusion.name" label="验收结论" name="receiptConclusionPicker" readonly right-icon="clear" @focus="showReceiptConclusions=true" @click-right-icon="clearReceiptConclusion"/>
        <van-popup v-model="showReceiptConclusions" position="bottom">
          <van-picker :columns="receiptConclusions" show-toolbar value-key="name" @cancel="showReceiptConclusions=false" @confirm="changeReceiptConclusion"/>
        </van-popup>
        <van-field :value="detail.rejectedReasonOfAcceptance.name" label="拒收原因" name="rejectedReasonOfAcceptancePicker" readonly right-icon="clear" @focus="showRejectedReasons=true"/>
        <van-popup v-model="showRejectedReasons" position="bottom">
          <van-picker :columns="rejectedReasons" show-toolbar value-key="name" @cancel="showRejectedReasons= false" @confirm="changeRejectedReason"/>
        </van-popup>
        <van-field :value="detail.opinion.name" label="处理意见" name="opinionPicker" readonly right-icon="clear" @focus="showOpinions=true" @click-right-icon="clearOpinion"/>
        <van-popup v-model="showOpinions" position="bottom">
          <van-picker :columns="opinions" show-toolbar value-key="name" @cancel="showOpinions= false" @confirm="changeOpinion"/>
        </van-popup>
        <van-field v-model="detail.notes" clearable label="备注" name="备注"/>
      </van-collapse-item>
    </van-collapse>
    <van-tabbar>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="12">
            <van-button block round style="margin: 16px;" type="info" @click="clear">重置</van-button>
          </van-col>
          <van-col span="12">
            <van-button block round style="margin: 16px;" type="primary" @click="save">保存</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import api from '@/api'
import debounce from 'lodash/debounce'
import { Toast } from 'vant'
import { findAll, findEnum, findOne, post } from '@/api/Api'
import { getUser, getWarehouseId } from '@/pdaView/utils'
import { BaseObject } from '@/api/dto/BaseObject'
import { ReceiptDetail, ReceiptOrder } from '@/api/dto/order/ReceiptOrder'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Party } from '@/api/dto/common/Party'
import { Container } from '@/api/dto/common/Container'
import { Item } from '@/api/dto/common/Item'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { License } from '@/api/dto/valueobject/License'
import { Permission } from '@/api/dto/valueobject/Permission'
import { Practice } from '@/api/dto/valueobject/Practice'
import { Quality } from '@/api/dto/valueobject/Quality'
import { DeviceHandler } from '@/deviceHelper'

export default {
  name: 'Inspect',
  data() {
    return {
      username: getUser().name,
      activeNames: [],
      order: new ReceiptOrder(),
      detail: new ReceiptDetail(),
      orderStatus: [],
      showStorageRooms: false,
      storageRooms: [],
      showReceiptConclusions: false,
      receiptConclusions: [],
      showRejectedReasons: false,
      rejectedReasons: [],
      showOpinions: false,
      opinions: [],
      summary: {
        inspector2: null,
        receivedCase: 0,
        totalQuantity: 0,
        receivedQuantity: 0,
        unreceivedQuantity: 0,
        rejectedQuantity: 0,
        acceptedQuantity: 0,
        unacceptedQuantity: 0,
        rejectedQuantityOfAcceptance: 0
      },
      warehouse: {
        id: getWarehouseId()
      }
    }
  },
  created() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result
      }
    })
    findOne('fieldFactory', { no: 'RECEIPT_CONCLUSION' }).then(res => {
      if (res.success) {
        this.receiptConclusions = res.result.dictionaries
      }
    })
    findOne('fieldFactory', { no: 'REJECT_REASON' }).then(res => {
      if (res.success) {
        this.rejectedReasons = res.result.dictionaries
      }
    })
    findOne('fieldFactory', { no: 'OPINION' }).then(res => {
      if (res.success) {
        this.opinions = res.result.dictionaries
      }
    })
  },
  activated() {
    let detail = this.$route?.params?.detail
    if (detail) {
      this.buildDetail(detail)
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push({ name: 'PdaIndex' })
    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    onAsnNoEntered: debounce(function(data) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.getOrder(value)
      }
    }, 300),
    getOrder(value) {
      if (!value) {
        Toast('请输入订单编号！')
        return
      }
      const args = {
        'order.no': value,
        asnOrderStatusRange: { start: 'SUBMITTED', end: 'INSPECTING' },
        refundable: false
      }
      findAll('receivingReceiptListFactory', args).then(res => {
        if (res.success) {
          if (res.result.length > 0) {
            this.buildOrder(res.result[0])
            this.clearDetail()
            this.activeNames = ['1']
            this.$refs._itemNo.focus()
          } else {
            Toast('未查询到相关单据或该单据已收货结束！')
            this.clear()
          }
        }
      })
    },
    onItemNoEntered: debounce(function(data) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.getDetail(value)
      }
    }, 300),
    getDetail(value) {
      if (!this.order.no) {
        Toast('请先扫描订单编号！')
        return
      }
      if (!value) {
        Toast('请输入商品编号！')
        return
      }
      findAll('receiptDetailFactory', { no: this.order.no, 'item.no': value, inspected: false, aggregate: true }).then(res => {
        if (res.success) {
          const views = res.result
          if (views.length === 1) {
            this.buildDetail(views[0])
            this.activeNames = ['6']
          } else if (views.length > 1) {
            this.$router.push({ name: 'ReceiptDetails', params: { details: views } })
          } else {
            Toast('未查询到相关商品明细')
          }
        }
      })
    },
    onContainerNo: debounce(function(data) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.getContainer(value)
      }
    }, 300),
    getContainer(no) {
      findOne('containerFactory', { 'container.no': no }).then(res => {
        if (res.success) {
          this.detail.container = new Container(res.result)
        }
      })
    },
    clear() {
      this.clearOrder()
      this.clearDetail()
      this.editable = true
    },
    clearOrder() {
      this.order = new ReceiptOrder()
    },
    clearDetail() {
      this.detail = new ReceiptDetail()
      this.summary = {
        inspector2: null,
        receivedCase: 0,
        totalQuantity: 0,
        receivedQuantity: 0,
        unreceivedQuantity: 0,
        rejectedQuantity: 0,
        acceptedQuantity: 0,
        unacceptedQuantity: 0,
        rejectedQuantityOfAcceptance: 0
      }
      this.storageRooms = []
    },
    clearStorageRoom() {
      this.detail.storageRoom = new StorageRoom()
    },
    clearReceiptConclusion() {
      this.detail.receiptConclusion = new Dictionary()
    },
    clearOpinion() {
      this.detail.opinion = new Dictionary()
    },
    buildOrder(view) {
      this.order = new ReceiptOrder(BaseObject.merge(view, 'order'))
      this.order.asnOrder.customer = new Party(view.customer)
    },
    buildDetail(view) {
      this.detail = new ReceiptDetail(BaseObject.merge(view, 'detail'))
      this.detail.item.legalAttribute = new Dictionary(view.legalAttribute)
      this.detail.item.dosageForm = new Dictionary(view.dosageForm)
      this.detail.lot.license = new License(view.license)
      this.detail.lot.permission = new Permission(view.permission)
      this.detail.lot.practice = new Practice(view.practice)
      this.detail.lot.quality = new Quality(view.quality)
      this.summary.totalQuantity = this.detail.invoiceQuantity
      this.summary.receivedQuantity = this.detail.receivedQuantity
      this.summary.rejectedQuantity = this.detail.rejectedQuantity
      this.summary.unreceivedQuantity = this.detail.invoiceQuantity - this.detail.receivedQuantity - this.detail.rejectedQuantity
      this.summary.acceptedQuantity = this.detail.acceptedQuantity
      this.summary.rejectedQuantityOfAcceptance = this.detail.rejectedQuantityOfAcceptance
      this.summary.unacceptedQuantity = this.detail.receivedQuantity - this.detail.acceptedQuantity - this.detail.rejectedQuantityOfAcceptance
      const args = {
        'query.no': 'limitStorageRoom',
        'sql': null,
        args: { whId: this.warehouse.id, itemId: this.detail.item.id }
      }
      post(api.adminQuery, {}, args).then(res => {
        if (res.success) {
          this.storageRooms = res.result.map(item => {
            return {
              id: item.id,
              name: item.name + '(' + item.limit + ')'
            }
          })
        }
      })
    },
    changeQuantity() {
      this.summary.receivedCase = Math.floor(this.detail.receivedQuantity / this.detail.pack.factor)
    },
    changeCase() {
      this.detail.receivedQuantity = this.summary.receivedCase * this.detail.pack.factor
    },
    changeStorageRoom(item) {
      this.detail.storageRoom = new StorageRoom(item)
      this.showStorageRooms = false
    },
    changeReceiptConclusion(item) {
      this.detail.receiptConclusion = new Dictionary(item)
      this.showReceiptConclusions = false
    },
    changeRejectedReason(item) {
      this.detail.rejectedReasonOfAcceptance = new Dictionary(item)
      this.showRejectedReasons = false
    },
    changeOpinion(item) {
      this.detail.opinion = new Dictionary(item)
      this.showOpinions = false
    },
    save() {
      if (this.order.owner.isNew()) {
        Toast('缺少单据信息')
        return
      }
      if (this.detail.item.isNew()) {
        Toast('缺少商品信息')
        return
      }
      if (this.detail.acceptedQuantity === 0 && this.detail.rejectedQuantityOfAcceptance === 0) {
        Toast('数量与拒验数量不能同时为0')
        return
      }
      if (this.detail.rejectedQuantityOfAcceptance > 0 && this.detail.rejectedReason.isNew()) {
        Toast('拒验数量大于0,请填写拒收原因')
        return
      }
      const args = {
        allocate: true,
        palletize: true,
        tag: false,
        generate: true,
        order: {
          ...this.order.toJSONObject(),
          warehouse: this.warehouse,
          details: [{
            ...this.detail.toJSONObject(),
            invoiceQuantity: this.detail.receivedQuantity,
            inspector: this.summary.inspector2 === null || this.summary.inspector2 === undefined ? this.username : this.username + ',' + this.summary.inspector2
          }]
        }
      }
      post(api.receivingReceiverAccept, { type: 'normalInboundReceiver' }, args).then(res => {
        if (res.success) {
          Toast('保存成功')
          this.clearDetail()
          this.detail.item = new Item()
        }
      })
    },
    printData(data) {
      if (!data.commandGroup) {
        return
      }
      const body1 = {
        'query.no': 'receivingCheckPrint',
        sql: null,
        args: {
          commandGroup: data.commandGroup
        }
      }
      post(api.adminQuery, {}, body1).then(res => {
        if (res.result.length > 0) {
          let Dt = []
          res.result.map(data => {
            data.zhxs = '入(' + parseInt(data.zhjs).toFixed(1) + '箱)'
            data.spmcgg = data.spmc + ' / ' + data.gg
            data.phxq = data.ph + ' / ' + data.xq
            data.sldw = '数量：' + data.sl + '(' + data.dw + ')'
            data.qyxx = data.qy + ' / ' + data.lc + data.zs + ' / ' + data.spbh
            data.dhrq = data.asnNo + ' / ' + data.scrq
            data.bdm = data.pzwh + '箱数量：' + parseInt(data.bzs).toFixed(1) + ' / ' + data.fdsx
            Dt.push(data)
          })
          if (Dt.length > 0) {
            const printList = []
            printList.push(
              {
                'PLAN_CODE': '080027',
                'WH_ID': 1000000001,
                'DATA': Dt
              }
            )
            DeviceHandler.printWithDataList(printList, () => post(api.receivingReceiverPrintUpdate, {}, { commandGroup: data.commandGroup }))
          }
        } else {
          this.$message.warning('无可打印数据')
        }
      })
    }
  }
}
</script>